import { menuForm } from '@/pages/menu-managements/menus/service';
import { FormError, validBlank, validMaxStr } from '@/validate';
import { validNum } from '@/validate/number';

export type MenuFormError = {
  titleJa: FormError;
  memo: FormError;
};

const { MAX_70, MAX_1000 } = validNum;

export const validateTitleJa = (
  titleJa: string,
  error: MenuFormError
): MenuFormError => {
  error.titleJa.isTouched = true;
  const label = menuForm.titleJa.label;
  const isMax = validMaxStr.check(titleJa, MAX_70);
  const isBlank = validBlank.check(titleJa);
  if (isBlank) error.titleJa.message = validBlank.message(label);
  if (isMax) error.titleJa.message = validMaxStr.message(label, MAX_70);
  error.titleJa.isError = isBlank || isMax;
  return error;
};

export const validateMemo = (
  memo: string,
  error: MenuFormError
): MenuFormError => {
  error.memo.isTouched = true;
  const label = menuForm.memo.label;
  const isMax = validMaxStr.check(memo, MAX_1000);
  if (isMax) error.memo.message = validMaxStr.message(label, MAX_1000);
  error.memo.isError = isMax;
  return error;
};
